import { Anchor } from "@mantine/core";
import type { DataTableColumn, DataTableProps as MantineTableProps } from "mantine-datatable";
import type { UserType } from "../../models/user";
import { StatusIndicator } from "../indicator/StatusIndicator";
import { DataTable, type DataTableProps } from "./DataTable";

export type UserDataTableProps<T extends UserType> = {
  userTypeString: string;
  additionalColumns?: DataTableColumn<T>[];
} & Required<Pick<DataTableProps<T>, "onDelete" | "onEdit" | "pagination" | "onPageChange" | "fetching">> &
  Pick<DataTableProps<T>, "onView" | "viewOnly"> &
  Pick<MantineTableProps<T>, "records" | "selectedRecords" | "onSelectedRecordsChange" | "onSortStatusChange" | "sortStatus">;

export function UserDataTable<T extends UserType>({ additionalColumns = [], userTypeString, onView, ...props }: UserDataTableProps<T>) {
  const columns: DataTableColumn<T>[] = [
    {
      accessor: "first_name",
      title: "Vorname",
      sortable: true,
      render: (user) => (onView ? <Anchor onClick={() => onView(user)}>{user.first_name}</Anchor> : user.first_name),
    },
    {
      accessor: "last_name",
      title: "Nachname",
      sortable: true,
      render: (user) => (onView ? <Anchor onClick={() => onView(user)}>{user.last_name}</Anchor> : user.last_name),
    },
    // {
    //     accessor: 'user.email',
    //     title: 'E-Mail',
    //     sortable: true,
    //     render: (userType) => <Anchor href={`mailto:${userType.user.email}`}>{userType.user.email}</Anchor>
    // },
    ...additionalColumns,
    {
      accessor: "user.active",
      title: "Aktiviert",
      width: "0%",
      sortable: true,
      render: (userType) => <StatusIndicator active={userType.user.active} />,
    },
  ];

  return <DataTable columns={columns} onView={onView} {...props} />;
}
